import BlockIcon from "@mui/icons-material/Block";
import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CustomSlider from "../../../SegmentBuilder/Shared/Slider";
import ColorSwatch from "../../../Swatch";
import Tabs from "../../../Tabs";
// import ToolAccordion from "../../../SegmentBuilder/Shared/ToolAccordion";
// import { ASSETS } from "../../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import { gradients } from "../../../../constants/background";
import useSegmentSettings from "../../../../hooks/useSegmentSetting";
import { setBgWallpaper } from "../../../../redux/actions/wheelWallpaper";
import { getSelectedSegment } from "../../../../redux/selectors/segmentBuilderSelectors";
import { hexToRgb } from "../../../../utils/helpers";
import CustomAccordion from "../../../Accordion";
import SegmentColor from "../../../SegmentSettings/children/SegmentColor";
import ImageView from "./children/Image";
import * as Styled from "./Wallpaper.styled";
import {
  patterns,
  StyledColorTypeSelector,
  StyledEmptyPattern,
  StyledPatternContainer,
  StyledRightIconContainer,
} from "./Wallpaper.styled"; // New file for additional styled components
import { usePaletteColor } from "../../../../hooks/usePaletteColor";
import UploadedImage from "../../Main/PortraitTab/UploadedImage";
import WallpaperImageSettings from "../../../WallpaperImageSettings";
import ImageCropper from "../../../ImageCropper";
import { useIfUserEligible } from "../../../../hooks/useIfUserEligible";
import { FEATURES } from "../../../../constants/features";
import EssentialPackageIcon from "@assets/images/packages/essentialPackageIcon.svg";
import { StyledTooltip } from "../../../IyugaTooltip";
import AutoScrollAccordion from "../AutoScrollAccordion";
// Self-contained SVG Patterns module (parametric checkerboard, dots, stripes,
// grid, zigzag, chevron … with scale + recolor). Rendered as a permanent
// "SVG Patterns" category in the wallpaper picker.
import { BackgroundPatternPanel } from "../../../backgroundPatterns";
import { BG_PATTERNS_ENABLED } from "../../../backgroundPatterns/featureFlag";
import {
  PROCEDURAL_LIBRARY_ENABLED,
  DesignPanel,
  LoopPanel,
  PresetPanel,
} from "../../../proceduralLibrary";
import GradientBuilder from "../../../gradientBuilder";

const Wallpaper = ({
  title = "Wallpaper",
  background = "#ffffff",
  slider2Value,
  slider2Change,
  slider2BoxTitle,
  handleWallpaperOverlayColorChange,
  wallpaperOverlayColor,
  handleSelectWallpaper,
  bgWallpaper,
  handleSelectPattern,
  isPattern,
  handleSelectColorType,
  handlePatternColorChange,
  handlePatternColorInitialChange,
  selectedColorType,
  patternColor,
  onBgWallpaperColorChange,
  currentBg,
  segmentBgColor,
  showAccordion = true,
  handleGradientColor,
  patternId,
  isShowTransparencySlider = true,
  handleSelectBackgroundResizeMode,
  resizeMode,
  customCategories = ["Colors", "Gradient", "Patterns", "Image"],
  showSuggestedColorPalette = true,
  showEmbedURLDisclaimer = false,
  cropAspectRatio = 16 / 9,
  huePercentage = 0,
  huePercentageChange,
  hueColor = "#ffffff",
  hueColorChange,
}) => {
  const dispatch = useDispatch();
  const { handleChange } = useSegmentSettings();
  // The procedural media libraries ride on the existing `handleGradientColor` →
  // bg_wallpaper slot (patterns/designs/loops, currentBg 3) or the image path
  // (presets, currentBg 2), so they need no new redux wiring. Each category is
  // additive and flag-gated: OFF = the picker behaves exactly as before.
  const categories = [
    ...customCategories,
    ...(BG_PATTERNS_ENABLED ? ["SVG Patterns"] : []),
    ...(PROCEDURAL_LIBRARY_ENABLED
      ? ["Loops", "Designs", "Preset wallpapers"]
      : []),
  ];
  const [selectedCategory, setSelectedCategory] = useState(customCategories[0]);
  const { getPaletteColor } = usePaletteColor();
  const [openCropper, setOpenCropper] = useState(false);
  const [originalImage, setOriginalImage] = useState(
    bgWallpaper?.src || bgWallpaper || null,
  ); // New state for original image

  // Effect to set originalImage when bgWallpaper is initially loaded or updated by non-cropper means
  useEffect(() => {
    if (bgWallpaper && !setOriginalImage) {
      setOriginalImage(bgWallpaper?.src || bgWallpaper);
    }
  }, [bgWallpaper]);

  // Handler for initial image selection (from Preset, Upload, Browse, Recent)
  const handleSelectInitialWallpaper = (value) => {
    handleSelectWallpaper(value);
    setOriginalImage(value); // Sets original for cropping
  };

  // Renders the flag-gated procedural library categories. Returns null for any
  // non-procedural category so the host cascade can fall through to its own tabs.
  const renderProceduralCategory = (cat) => {
    const segColor = getPaletteColor
      ? getPaletteColor(segmentBgColor)
      : undefined;
    switch (cat) {
      case "SVG Patterns":
        return (
          <BackgroundPatternPanel
            value={bgWallpaper}
            onApply={handleGradientColor}
          />
        );
      case "Loops":
        return (
          <LoopPanel onApply={handleGradientColor} segmentColor={segColor} />
        );
      case "Designs":
        return (
          <DesignPanel
            value={bgWallpaper}
            onApply={handleGradientColor}
            segmentColor={segColor}
          />
        );
      case "Preset wallpapers":
        return <PresetPanel onSelect={handleSelectInitialWallpaper} />;
      default:
        return null;
    }
  };

  const PROCEDURAL_CATEGORIES = [
    "SVG Patterns",
    "Loops",
    "Designs",
    "Preset wallpapers",
  ];

  const getWallpaperBgColor = useCallback((color) => {
    const [r, g, b] = hexToRgb(color);
    return `rgba(${r},${g},${b},0.5)`;
  }, []);

  const { isEligible } = useIfUserEligible(FEATURES.WHEEL_WALLPAPER_IMAGE);
  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
    if (newValue === "Patterns") {
      handleSelectPattern(patternId ? patternId : 0);
      // handlePatternColorChange(patternColor ? patternColor : selectedSegmentColor);
      // handleWallpaperOverlayColorChange(wallpaperOverlayColor);
    }
  };

  const categoriesWithIcons = categories.map((category) => {
    const config = {
      label: category,
      value: category,
    };

    // Add tooltip only to Image category when not eligible
    if (category === "Image" && !isEligible) {
      config.customIcon = (
        <StyledTooltip
          title={"Essential Tier feature"}
          arrow
          placement="bottom"
          color={"#325AE9"}
          textColor={"#fff"}
        >
          <img
            src={EssentialPackageIcon}
            alt="info"
            style={{ width: "20px", height: "20px" }}
          />
        </StyledTooltip>
      );
    }

    return config;
  });

  const RightIconComponent = () => {
    return (
      <StyledRightIconContainer>
        {currentBg === 0 || currentBg === 3 ? (
          <StyledRightIconContainer bgColor={getPaletteColor(segmentBgColor)} />
        ) : currentBg === 1 ? (
          <StyledRightIconContainer bgColor={wallpaperOverlayColor}>
            {patterns.find((pattern) => pattern.id === patternId)?.component &&
              React.createElement(
                patterns.find((pattern) => pattern.id === patternId).component,
                {
                  color: getPaletteColor(patternColor),
                },
              )}
          </StyledRightIconContainer>
        ) : bgWallpaper ? (
          <Styled.SwatchOverlayImage
            overlayColor={getWallpaperBgColor(wallpaperOverlayColor)}
            isPattern={isPattern}
          >
            <Styled.SwatchBackgroundImage src={bgWallpaper} alt="Wallpaper" />
          </Styled.SwatchOverlayImage>
        ) : (
          <BlockIcon />
        )}
      </StyledRightIconContainer>
    );
  };

  const ColorTypeSelector = ({
    onClick,
    isSelected,
    wallpaperOverlayColor,
    bgWallpaper,
    patternColor,
    marginTop,
    colorType,
  }) => {
    return (
      <StyledColorTypeSelector
        onClick={onClick}
        isSelected={isSelected}
        wallpaperOverlayColor={wallpaperOverlayColor}
      >
        <div style={{ marginTop }}>
          {colorType === 2 &&
            patternId > 0 &&
            patterns.find((pattern) => pattern.id === patternId)?.component &&
            React.createElement(
              patterns.find((pattern) => pattern.id === patternId).component,
              {
                color: getPaletteColor(patternColor),
              },
            )}
        </div>
      </StyledColorTypeSelector>
    );
  };

  const renderColorsTab = useCallback(() => {
    return (
      <SegmentColor
        isExpanded={true}
        showTabs={false}
        currentColor={wallpaperOverlayColor}
        title={"Color"}
        onColorChange={onBgWallpaperColorChange}
        wallpaperOverlayColor={getWallpaperBgColor(wallpaperOverlayColor)}
        showSuggestedColorPalette={showSuggestedColorPalette}
      />
    );
  }, [
    getWallpaperBgColor,
    onBgWallpaperColorChange,
    wallpaperOverlayColor,
    showSuggestedColorPalette,
  ]);

  const selectedSegment = useSelector(getSelectedSegment);

  useEffect(() => {
    if (patternColor === undefined) {
      handlePatternColorInitialChange("suggested_color_0");
    }
  }, [selectedSegment, patternColor, handlePatternColorInitialChange]);
  const renderPatternsTab = () => {
    const selectedPattern = patterns?.find(
      (pattern) => pattern?.id === patternId,
    );
    const PatternComponent = selectedPattern ? selectedPattern.component : null;

    return (
      <>
        {currentBg === 1 && patternId >= 1 && PatternComponent ? (
          <>
            <Styled.OverlayContainer bgColor={wallpaperOverlayColor}>
              <div style={{ marginLeft: "-10px" }}>
                {PatternComponent &&
                  React.createElement(PatternComponent, {
                    color: getPaletteColor(patternColor),
                  })}
              </div>
            </Styled.OverlayContainer>
            <Stack
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              mt={2}
            >
              <ColorTypeSelector
                onClick={() => handleSelectColorType(0)}
                isSelected={false}
                wallpaperOverlayColor={"white"}
                patternColor={"black"}
                marginTop={"0"}
                colorType={2}
              />

              <ColorTypeSelector
                onClick={() => handleSelectColorType(1)}
                isSelected={selectedColorType === 1}
                wallpaperOverlayColor={wallpaperOverlayColor}
                patternColor={getPaletteColor(patternColor)}
                marginTop={"0"}
                colorType={1}
              />
              <ColorTypeSelector
                onClick={() => handleSelectColorType(2)}
                isSelected={selectedColorType === 2}
                wallpaperOverlayColor={
                  patternColor !== undefined
                    ? getPaletteColor(patternColor)
                    : "suggested_color_0"
                }
                patternColor={getPaletteColor(patternColor)}
                colorType={1}
              />
            </Stack>
          </>
        ) : null}

        {(selectedColorType === 0 || selectedColorType == null) && (
          <Styled.GridContainer>
            {patterns.map((pattern, index) =>
              pattern.id === 0 ? (
                <StyledEmptyPattern
                  key={index}
                  onClick={() => {
                    handleSelectPattern(pattern?.id);
                  }}
                  isSelected={patternId === 0}
                >
                  <BlockIcon style={{ color: "#d5d9e0", fontSize: "40px" }} />
                </StyledEmptyPattern>
              ) : (
                <StyledPatternContainer
                  key={index}
                  onClick={() => {
                    handleSelectPattern(pattern?.id);
                  }}
                  isSelected={patternId === pattern.id}
                >
                  {pattern.component &&
                    React.createElement(pattern.component, {
                      color: "black",
                    })}
                </StyledPatternContainer>
              ),
            )}
          </Styled.GridContainer>
        )}

        {[1, 2].includes(selectedColorType) && (
          <SegmentColor
            showTabs={false}
            currentColor={wallpaperOverlayColor}
            title={"Color"}
            onColorChange={
              selectedColorType === 2
                ? handlePatternColorChange
                : handleWallpaperOverlayColorChange
            }
            wallpaperOverlayColor={getWallpaperBgColor(wallpaperOverlayColor)}
            showSuggestedColorPalette={showSuggestedColorPalette}
          />
        )}
      </>
    );
  };

  return (
    <>
      {showAccordion ? (
        <CustomAccordion
          title={title}
          icon={<RightIconComponent />}
          onChange={() => {}}
        >
          {/* <ToolAccordion
          accordionIcon={ASSETS.segmentEditor.ContainerWallpaper}
          title={title}
          AccordionSummaryStyle={{ p: 0, m: 0 }}
          RightIconComponent={RightIconComponent}
        > */}

          <Styled.Container>
            <Tabs
              categoriesWithIcons={categoriesWithIcons.filter(
                (e) => e.value !== "Patterns",
              )}
              selectedCategory={selectedCategory}
              onCategoryChange={handleCategoryChange}
              color={"#81459B"}
              indicatorColor="#C283DA"
            />
            {selectedCategory === "Colors" ? (
              renderColorsTab()
            ) : selectedCategory === "Image" ? (
              <>
                {bgWallpaper &&
                  !bgWallpaper.includes("linear") &&
                  currentBg == 2 && (
                    <UploadedImage
                      handleRemoveImage={() =>
                        handleChange("addBgWallpaper", 0, "")
                      }
                      image={bgWallpaper?.src || bgWallpaper}
                      setOpen={setOpenCropper}
                    />
                  )}

                <ImageView
                  handleRemoveImage={() =>
                    handleChange("addBgWallpaper", 0, "")
                  }
                  handleSelectWallpaper={handleSelectInitialWallpaper}
                  handleEditImage={(value) => {
                    handleChange("addBgWallpaper", 0, value);
                    setOriginalImage(value);
                  }}
                  bgWallpaper={bgWallpaper}
                  isPattern={isPattern}
                  currentBg={currentBg}
                  resizeMode={resizeMode}
                  handleSelectBackgroundResizeMode={
                    handleSelectBackgroundResizeMode
                  }
                  showPreview={false}
                />
                {bgWallpaper &&
                  !bgWallpaper.includes("linear") &&
                  currentBg == 2 && (
                    <AutoScrollAccordion
                      title="Image Tint"
                      RightIconComponent={() => (
                        <div
                          style={{
                            width: "24px",
                            height: "24px",
                            backgroundColor: hueColor,
                            borderRadius: "50%",
                            border: "1px solid #a2a2a2",
                          }}
                        ></div>
                      )}
                    >
                      <WallpaperImageSettings
                        huePercentage={huePercentage}
                        huePercentageChange={huePercentageChange}
                        hueColor={hueColor}
                        hueColorChange={hueColorChange}
                      />
                    </AutoScrollAccordion>
                  )}
              </>
            ) : selectedCategory === "Patterns" ? (
              renderPatternsTab()
            ) : PROCEDURAL_CATEGORIES.includes(selectedCategory) ? (
              renderProceduralCategory(selectedCategory)
            ) : selectedCategory === "Gradient" ? (
              <Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    paddingLeft: "8px",
                    marginBottom: "8px",
                    fontFamily: "DM Sans",
                  }}
                >
                  Preset
                </Typography>
                <Grid container spacing={1} alignItems="center">
                  {gradients?.map((color) => (
                    <Grid item key={color}>
                      <Box onClick={() => handleGradientColor(color)}>
                        <ColorSwatch
                          color={color}
                          borderColor={background === color && "#BBBBBB"}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
                <GradientBuilder
                  value={background}
                  onApply={handleGradientColor}
                />
              </Box>
            ) : null}
            {isShowTransparencySlider && (
              <Stack mx={1}>
                <CustomSlider
                  title={slider2BoxTitle}
                  value={slider2Value}
                  onChange={slider2Change}
                  filledColor="#F79A00"
                  thumbColor="#F79A00"
                  bgColor="rgba(254, 235, 213, 0.9)"
                />
              </Stack>
            )}
          </Styled.Container>
        </CustomAccordion>
      ) : (
        <Styled.Container>
          <Tabs
            categoriesWithIcons={categoriesWithIcons.filter(
              (e) => e.value !== "Patterns",
            )}
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            color={"#81459B"}
            indicatorColor="#C283DA"
          />
          {bgWallpaper && !bgWallpaper.includes("linear") && currentBg == 2 && (
            <UploadedImage
              handleRemoveImage={() => dispatch(setBgWallpaper("", 0))}
              image={bgWallpaper?.src || bgWallpaper}
              setOpen={setOpenCropper}
            />
          )}

          {selectedCategory === "Colors" ? (
            renderColorsTab()
          ) : selectedCategory === "Image" ? (
            <>
              <ImageView
                handleRemoveImage={() => dispatch(setBgWallpaper("", 0))}
                handleSelectWallpaper={handleSelectInitialWallpaper}
                handleEditImage={(value) => {
                  dispatch(setBgWallpaper(value, 0));
                  setOriginalImage(value);
                }}
                bgWallpaper={bgWallpaper}
                isPattern={isPattern}
                currentBg={currentBg}
                showPreview={false}
                showEmbedURLDisclaimer={showEmbedURLDisclaimer}
              />

              {bgWallpaper &&
                !bgWallpaper.includes("linear") &&
                currentBg == 2 && (
                  <AutoScrollAccordion
                    title="Image Tint"
                    RightIconComponent={() => (
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          backgroundColor: hueColor,
                          borderRadius: "50%",
                          border: "1px solid #a2a2a2",
                        }}
                      ></div>
                    )}
                  >
                    <WallpaperImageSettings
                      huePercentage={huePercentage}
                      huePercentageChange={huePercentageChange}
                      hueColor={hueColor}
                      hueColorChange={hueColorChange}
                    />
                  </AutoScrollAccordion>
                )}
            </>
          ) : selectedCategory === "Patterns" ? (
            renderPatternsTab()
          ) : selectedCategory === "SVG Patterns" ? (
            <BackgroundPatternPanel
              value={bgWallpaper}
              onApply={handleGradientColor}
            />
          ) : selectedCategory === "Gradient" ? (
            <Box>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  paddingLeft: "8px",
                  marginBottom: "8px",
                  fontFamily: "DM Sans",
                }}
              >
                Preset
              </Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Box
                    onClick={() => handleGradientColor("transparent")}
                    sx={{
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderRadius: "50%",
                    }}
                  >
                    <BlockIcon />
                  </Box>
                </Grid>
                {gradients?.map((color) => (
                  <Grid item key={color}>
                    <Box onClick={() => handleGradientColor(color)}>
                      <ColorSwatch
                        color={color}
                        borderColor={background === color && "#BBBBBB"}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
              <GradientBuilder
                value={background}
                onApply={handleGradientColor}
              />
            </Box>
          ) : null}
          {isShowTransparencySlider && (
            <Stack mx={1}>
              <CustomSlider
                title={slider2BoxTitle}
                value={slider2Value}
                onChange={slider2Change}
                filledColor="#F79A00"
                thumbColor="#F79A00"
                bgColor="rgba(254, 235, 213, 0.9)"
              />
            </Stack>
          )}
        </Styled.Container>
      )}

      <ImageCropper
        src={originalImage}
        open={openCropper}
        handleClose={() => setOpenCropper(false)}
        handleEditImage={handleSelectWallpaper}
        lockedAspectRatio={cropAspectRatio}
      />
    </>
  );
};

export default Wallpaper;
